import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
 
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <Stack spacing={2} direction="row"></Stack>
    </GridToolbarContainer>
  );
}
 
const CompletedJobDisplayGrid = ({ rows, columns }) => {
  return (
    <>
      <Box sx={{ height: "500px", width: "96%", marginTop: "20px" }}>
        <DataGrid
          slots={{
            toolbar: CustomToolbar,
          }}
          rowHeight={50}
          rows={rows}
          columns={columns}
          sx={{
            "& .MuiDataGrid-row": {
              backgroundColor: "dadfe1",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#dee3eb",
              color: "#ab1368",
              fontSize: 16,
            },
            overflowX: "scroll",
            border: "2px solid #ab1368",
            borderRadius: "5px",
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};
 
export default CompletedJobDisplayGrid;